const VL = {
  locale: "fr",
  messages: {
    flowScene: {
      filters: {
        flowTypes: {
          car: "VL",
        },
      },
      flowType: {
        car: "{count, plural, one {VL} other {VL}}",
        short_car: "VL",
      },
    },
    indicatorsScene: {
      table: {
        header: {
          car: "VL",
          cars: "VL",
        },
      },
    },
  },
};

export default VL;
